
import React, { useContext, useState } from 'react';
import { VirtualScroller } from 'primereact/virtualscroller';
import { Skeleton } from 'primereact/skeleton';
import { classNames } from 'primereact/utils';
import { ToolsContext, ToolsDispatchContext } from '../../ToolsContext.js';
import { useQueryGtfsResource } from '../../Queries.js';
import { ProgressSpinner } from 'primereact/progressspinner';
import { PlatformIndicator } from '../../components/PlatformIndicator.js';
import { InputFilter } from '../../components/InputFilter.js';
import { useMap } from 'maplibre-react-components';
import { popup } from 'leaflet';

export function StopPicker() {
    const { isPending, error, data } = useQueryGtfsResource('stops');
    const [filterText, setFilterText] = useState('');

    let GStops = data;

    if (isPending) {
        return (
            <ProgressSpinner className="flex justify-content-center"/>
        );
    }

    if (error) {
        return (
            <>
                <i className="fa-solid fa-face-frown fa-5x"></i><br />
                Wystąpił błąd ładowania przystanków: {error.message}
            </>
        )
    }

    return (
        <>
            <InputFilter filterText={filterText} onFilterTextChange={setFilterText} placeholder='Znajdź przystanek' />
            <StopList filterText={filterText} GStops={GStops} />
        </> 
    )
}

function StopList({ GStops, filterText, panelHeight }) {
    const tool = useContext(ToolsContext);
    const dispatch = useContext(ToolsDispatchContext);
    const map = useMap('map-ml');
    const items = [];

    if (!map) return;

    Object.entries(GStops).forEach(([key, element]) => {
        if (element.stop_name.toLowerCase().indexOf(
            filterText.toLowerCase()
        ) === -1 &&
            /*         element.tts_stop_name.toLowerCase().indexOf(
                        filterText.toLowerCase()
                    ) === -1 && */
            element.stop_id.toLowerCase().indexOf(
                filterText.toLowerCase()
                /*      ) === -1 &&
                            element.platform_code.toLowerCase().indexOf(
                            filterText.toLowerCase()
                        ) === -1 && 
                            element.stop_code.toLowerCase().indexOf(
                            filterText.toLowerCase()    */
                // TODO: Podczas wyszukiwania upewnić się, że tts_stop_name, platform_code, stop_code to stringi             
            ) === -1) {
            return;
        }
        items.push(element);
    });

    const itemTemplate = (item, options) => {
        const className = classNames('hover:text-orange-700 cursor-pointer align-items-center p-2', {
            'surface-hover': options.odd
        });

        return (
            <div
                key={item.stop_id}
                className={className}
                style={{
                    height: options.props.itemSize + 'px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                }}
                onClick={() => {
                    dispatch({
                        type: 'changed',
                        newTool: {
                            ...tool,
                            selection: item.stop_id, // zaznacz przystanek na mapie
                            propertyEditor: {   // i wyświetl w edytorze
                                edit: item,
                                popup: true
                            }
                        }
                    })
                    map.jumpTo({center: [item.stop_lon,item.stop_lat], zoom: 19});
                }}
            >
                🚏 {item.stop_name}
                <PlatformIndicator platformCode={item.platform_code} /><br />
                <span className='text-xs text-200'>
                    <b className='mr-3'>{item.stop_id}</b>
                    {
                        (item.stats.trips_count > 0)
                            ? <><b>{item.stats.trips_count}</b> postojów, <b>{Object.keys(item.stats.routes).length}</b> linii.</>
                            : <>Brak postojów na tym przystanku</>
                    }
                </span>
            </div>
        );
    };

    const loadingTemplate = (options) => {
        const className = classNames('flex align-items-center p-2', {
            odd: options.odd
        });

        return (
            <div className={className} style={{ height: '40px' }}>
                <Skeleton width={options.even ? '60%' : '50%'} height="1.3rem" />
            </div>
        );
    };

    return (
        <>
            <VirtualScroller autoSize={true} items={items} itemSize={50} itemTemplate={itemTemplate} showLoader /*  delay={100} */ loadingTemplate={loadingTemplate} className="border-1 surface-border border-round w-full h-full" />
        </>
    );
}

